import classnames from "classnames";
import { type ReactNode, forwardRef } from "preact/compat";

export type ScrollSnapCarouselContainerProps = {
  children: ReactNode;
};

export const ScrollSnapCarouselContainer = forwardRef<
  HTMLDivElement,
  ScrollSnapCarouselContainerProps
>(({ children }, ref) => {
  return (
    <div
      className="h-full overflow-x-scroll w-full flex"
      style={{
        scrollbarWidth: "none",
        scrollSnapType: "x mandatory",
      }}
      ref={ref}
    >
      {children}
    </div>
  );
});

export type ScrollSnapCarouselItemProps = {
  children: ReactNode;
  animation?: {
    duration: number;
    animate: boolean;
    type: "smooth-scroll" | "fade";
  };
};

export const ScrollSnapCarouselItem = forwardRef<
  HTMLDivElement,
  ScrollSnapCarouselItemProps
>(({ children, animation }, ref) => {
  return (
    <div
      style={{
        flex: "0 0 100%",
        scrollSnapAlign: "start",
        scrollSnapStop: "always",
        ...(animation &&
          animation.type === "fade" && {
            transitionProperty: "opacity",
            transitionDuration: `${animation.duration}ms`,
          }),
      }}
      aria-current="false"
      className={classnames(
        "flex relative h-full items-center w-full lg:px-16",
        {
          [`ease-in-out ${
            animation?.animate ? "opacity-100" : "opacity-0"
          } animate-fade-in`]: animation && animation.type === "fade",
        },
      )}
      ref={ref}
    >
      {children}
    </div>
  );
});

// export const ScrollSnapCarouselItem: FC<CarouselItemProps> = ({
//   children,
//   animation,
// }) => {
//   return (
//     <div
//       style={{
//         flex: "0 0 100%",
//         scrollSnapAlign: "start",
//       scrollSnapStop: "always",
//         ...(animation &&
//           animation.type === "fade" && {
//             transitionProperty: "opacity",
//             transitionDuration: `${animation.duration}ms`,
//           }),
//       }}
//       aria-current="false"
//       className={classnames(
//         "flex relative h-full items-center w-full lg:px-16",
//         {
//           [`ease-in-out ${
//             animation?.animate ? "opacity-100" : "opacity-0"
//           } animate-fade-in`]: animation && animation.type === "fade",
//         },
//       )}
//     >
//       {children}
//     </div>
//   );
// };
